import { Injectable } from '@angular/core';
import { MenuItem } from '@openng/optimus-ui/api';
import { map, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private onBreadCrumbGenerationSubject: Subject<{
    home: MenuItem;
    items: MenuItem[];
  }> = new Subject<{
    home: MenuItem;
    items: MenuItem[];
  }>();
  activeFolderName: string = '';
  onBreadCrumbGeneration$ = this.onBreadCrumbGenerationSubject.asObservable();

  setBreadCrumbs(home: MenuItem, items: MenuItem[]): void {
    this.onBreadCrumbGenerationSubject.next({ home, items });
    this.activeFolderName = items[items.length - 1]?.label ?? 'All Files';
  }
}
